module.exports = __webpack_public_path__ + "_/_/src/assets/firesafety/Fire-Door-FD30/legend.png";